module.exports = __webpack_public_path__ + "images/img-2xC169l.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/ru/3.png
// module id = 2328
// module chunks = 0